// src/App.jsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';

// Layout & Main Dashboard
import DashboardLayout from './layouts/DashboardLayout';
import Users from './pages/Users/Users';

// Quick Access Pages
import Practice from './pages/QuickAccess/Practice';
import QuizTests from './pages/QuickAccess/QuizTests';
import MockTests from './pages/QuickAccess/MockTests';
import TypingTests from './pages/QuickAccess/TypingTests';
import PdfContents from './pages/QuickAccess/PdfContents';
import CogniReader from './pages/QuickAccess/CogniReader';

// The new interface component
import PracticeTestInterface from './components/PracticeTestInterface/PracticeTestInterface';

// Auth Components
import Login from './components/Login/Login';
import Signup from './components/Signup/Signup';

// --- LANDING PAGE COMPONENT ---
function LandingPage() {
  const { user, authLoading } = useAuth();
  const navigate = useNavigate();

  if (authLoading) return null; 
  if (user) return <Navigate to="/users" replace />;

  return (
    <div style={{ textAlign: 'center', padding: '10vh 20px' }}>
      <h1>Welcome to GangaTricks</h1>
      <p>Access your personalized dashboard and track your learning progress.</p>
      
      <div style={{ marginTop: '30px', display: 'flex', gap: '15px', justifyContent: 'center' }}>
        <button onClick={() => navigate('/login')} className="btn-primary">
          Log In
        </button>
        <button onClick={() => navigate('/signup')} className="btn-secondary" style={{ padding: '10px 20px', cursor: 'pointer' }}>
          Create Account
        </button>
      </div>
    </div>
  );
}

// --- AUTH WRAPPER ---
function AuthWrapper({ initialView }) {
  const [view, setView] = React.useState(initialView);
  const { user } = useAuth();

  if (user) return <Navigate to="/users" replace />;

  if (view === 'login') return <Login onToggleView={() => setView('signup')} />;
  return <Signup onToggleView={() => setView('login')} />;
}

// --- MAIN APP ENTRY ---
export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        
        <Route path="/login" element={<AuthWrapper initialView="login" />} />
        <Route path="/signup" element={<AuthWrapper initialView="signup" />} />

        {/* The Dashboard Routes */}
        <Route path="/users" element={<DashboardLayout />}>
          <Route index element={<Users />} />
          
          {/* Quick Access Nested Routes */}
          <Route path="practice" element={<Practice />} />
          
          {/* NEW ROUTE: Practice Interface with Dynamic Post ID */}
          <Route path="practice/pinterface/:postId" element={<PracticeTestInterface />} />
          
          <Route path="quiz" element={<QuizTests />} />
          <Route path="mock-tests" element={<MockTests />} />
          <Route path="typing" element={<TypingTests />} />
          <Route path="pdfs" element={<PdfContents />} />
          <Route path="cogni-reader" element={<CogniReader />} />
        </Route>
      </Routes>
    </Router>
  );
}